<template>
    <div class="search-form">
        <form action="/catalog/search/" method="get" class="search-form__form">
            <input
                v-model="queryProduct"
                name="query"
                autocomplete="off"
                @input="$event.target.composing = false"
                type="text"
                class="search-form__field"
                placeholder="Искать в каталоге">
            <button class="search-form__submit" type="submit">
                <i class="fa fa-magnifying-glass" v-if="!requestProcess"></i>
                <i class="fa fa-spinner fa-spin-pulse" v-if="requestProcess"></i>
            </button>
        </form>
        <div
            v-if="resultsNotEmpty"
            class="search-form__results search-results">
            <div
                class="search-results__categories results-group"
                v-if="categoriesResults && categoriesResults.length > 0">
                <div class="results-group__title">В категориях</div>
                <ul class="results-group__items search-result-items">
                    <li
                        v-for="category in categoriesResults"
                        class="search-result-items__item">
                        <a :href="category.get_absolute_url" class="search-result-item">
                            <span
                                v-if="category.thumbnail_icon"
                                class="search-result-item__icon">
                                <img
                                    :src="baseUrl+category.thumbnail_icon"
                                    class="search-result-item__img">
                            </span>
                            <span class="search-result-item__content">
                                <span class="search-result-item__name">{{ category.name }}</span>
                                <span
                                    v-if="category.root_category_name"
                                    class="search-result-item__root-category">
                                    {{ category.root_category_name }}
                                </span>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            <div
                class="search-results__products"
                v-if="productsResults && productsResults.length > 0">
                <div class="results-group__title">В товарах</div>
                <ul class="results-group__items search-result-items">
                    <li
                        v-for="product in productsResults"
                        class="search-result-items__item">
                        <a class="search-result-item" :href="product.get_absolute_url">
                            <span
                                v-if="product.thumbnail_icon"
                                class="search-result-item__icon search-result-item__icon--product">
                                <img
                                    :src="baseUrl+product.thumbnail_icon"
                                    class="search-result-item__img search-result-item__img--product">
                            </span>
                            <span class="search-result-item__content">
                                <span class="search-result-item__code product-code">
                                    <span class="product-code__label">Код товара:</span>
                                    <span class="product-code__value">{{ product.id }}</span>
                                </span>
                                <span class="search-result-item__root-category">
                                    {{ product.category.name }}
                                </span>
                                <span class="search-result-item__name">
                                    {{ product.name }}
                                </span>
                                <span class="search-result-item__price product-search-price">
                                    <span class="product-search-price__value">
                                        {{ product.price.toFixed(0) }} руб.
                                    </span>
                                    <span
                                        v-if="product.is_sale"
                                        class="product-search-price__value product-search-price__value--raw">
                                        {{ product.price_raw.toFixed(0) }}
                                    </span>
                                </span>
                                
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="search-results__actions">
                <a :href="'/catalog/search/?query='+queryProduct" class="btn btn-outline btn-outline--tertiary search-results__btn">Все результаты</a>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

import { settings } from '../../variables'

export default {

    name: 'SearchAutocomplete',

    components: {

    },

    data() {
        return {
            queryProduct: null,
            requestProcess: false,
            searchResults: null,

            categoriesResults: null,
            productsResults: null,

            baseUrl: settings.apiBaseUrl
        }
    },

    computed: {
        resultsNotEmpty () {
            if (this.categoriesResults && this.categoriesResults.length > 0) {
                return true
            }
            if (this.productsResults && this.productsResults.length > 0) {
                return true
            }
            return false
        }
    },

    watch: {
        queryProduct(new_query, old_query) {

            if (new_query && new_query.length > 2 && new_query != old_query && !this.requestProcess) {
                this.searchProduct()
            }
            else if (new_query.length < 3) {
                this.requestProcess = false
                this.categoriesResults = null
                this.productsResults = null
            }
        },
    },

    mounted() {
        
    },

    methods: {
        searchProduct () {
            this.requestProcess = true
            this.offerAddByBarcode = false
            this.searchRequest()
        },

        searchRequest () {
            axios.get('/catalog/api/search/', {params: {query: this.queryProduct}}).then(
                (response) => {
                    this.categoriesResults = response.data.categories
                    this.productsResults=response.data.products
                    this.requestProcess = false
                }
            )
        }
    },

}
</script>


<style lang="scss">
    
</style>
